<template>
	<div
		class="c-article"
		:class="width === 'narrow' ? 'c-article--narrow' : ''"
	>
		<div
			class="c-article__content"
			ref="content"
			:class="{ 'c-article__content--crop': isCropped }"
		>
			<slot name="content"></slot>
		</div>

		<button
			type="button"
			v-if="isCropped"
			@click="showAll()"
			class="c-button c-button--noboxshadow c-button--icon c-article__more"
		>
			<span class="c-button--right">Visa hela texten</span>
			<v-icon
				name="icon-arrow"
				size="xxs"
				cssModifiers="c-article__more-icon"
			></v-icon>
		</button>
	</div>
</template>

<script>
import VIcon from "../../components/icon/VIcon.vue";
export default {
	name: "VArticle",
	components: {
		VIcon
	},
	props: {
		crop: {
			type: String,
			default: ""
		},
		width: {
			type: String,
			default: ""
		}
	},
	data: () => ({
		isCropped: false,
		cropWidth: 0
	}),
	methods: {
		toggleCrop() {
			if (window.innerWidth < this.cropWidth) {
				this.isCropped = true;
			} else {
				this.isCropped = false;
			}
		},
		showAll() {
			this.isCropped = false;
			window.removeEventListener("resize", this.toggleCrop);
		}
	},
	mounted() {
		if (this.$refs.content.clientHeight > 449) {
			if (this.crop !== "") {
				if (this.crop === "small") {
					this.cropWidth = 600;
				} else if (this.crop === "medium") {
					this.cropWidth = 1025;
				} else if (this.crop === "always") {
					this.isCropped = true;
				}
			}

			if (!this.isCropped) {
				window.addEventListener("resize", this.toggleCrop);
				if (window.innerWidth < this.cropWidth) {
					this.toggleCrop();
				}
			}
		}
		this.$refs.content.style.display = "block";
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.toggleCrop);
	}
};
</script>
